import React from 'react'

import Image from '../../../assets/images/general-icons/network-settings.svg'
import { Card, CardHeader } from '../../../components'

interface UpdateSettingsCardProps {
  addSpacing?: boolean
  children: React.ReactNode
}

const Header = () => (
  <CardHeader>
    <img alt="" src={Image} />
  </CardHeader>
)

export const UpdateSettingsCard = ({
  addSpacing,
  children,
  ...props
}: UpdateSettingsCardProps) => (
  <Card {...props} header={<Header />} addSpacing={addSpacing}>
    {children}
  </Card>
)

export default UpdateSettingsCard
